import getIdentifierType from "../getIdentifierType";
// import getMarkIdentifiers from '../getMarkIdentifiers';

/**
 * Gets the node's identifier.
 * The node identifier is based on the parent's identifier, the node's type, and the current count of that type.
 * e.g. /p[1]/a[1] = the first <a> tag within the first <p> tag
 *
 * A node will only have its own identifier if it has a corresponding HTML element.
 * e.g. A text node will not have its own identifier.
 *
 * @param {object} node
 * @param {object} nodeTypeCount
 * @param {string} parentIdentifier
 * @returns {string} identifier
 */
const getIdentifier = (node, nodeTypeCount, parentIdentifier = "") => {
  // The type used in the identifier (i.e. the one used in the Read page plugin) does not always match the ProseMirror identifier.
  const identifierType = getIdentifierType(node);

  // The read page omits the paragraph within the <li> element which is added in ProseMirror / Alexandria.
  // Because of this, we ignore the element and don't include it in the identifier.
  // if (parentIdentifier?.includes('/li') && identifierType === 'p') {
  //   return null;
  // }

  const count = nodeTypeCount[node.type];

  if (identifierType && count) {
    return parentIdentifier + `/${identifierType}[${count}]`;
  }

  // const marksIdentifier = getMarkIdentifiers(node, nodeTypeCount);

  // if (marksIdentifier) {
  //   return parentIdentifier + marksIdentifier;
  // }

  return null;
};

export default getIdentifier;
